import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import store from '../store';
import supplier from './supplier.js';
import routerSurfaces from './routerSurface.js';
import _ from "lodash";
import axios from '@/util/axios.js'
import api from '@/util/api.js'

Vue.use(VueRouter);
const routes = [
  {
    path: '/print/:id',
    name: 'print',
    component: () => import('@/views/Print'),
    meta: {
      rules: 0,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      rules: 0,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      rules: 0,
    },
  }
];

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
  });

let newArray = []; // 存储匹配完成的菜单

const router = createRouter();

function matchNestedObjects(arr1, arr2) {
  const result = [];
  let local_router_hash = {};
  let is_menu_level = arr2[0].path.split('/').length - 1;
  arr2.forEach((item) => {
    local_router_hash[item.path] = item;
    if (is_menu_level == 3) {
      if (item.children) delete item.children
      result.push(item);
    }
  });
  if (is_menu_level == 3) return result;
  arr1.forEach((item) => {
    if (local_router_hash[item.path]) {
      let obj = {
        ...local_router_hash[item.path],
      }
      obj.meta.name = item.auth_name
      if (obj.children) {
        delete obj.children
        obj.children = matchNestedObjects(item.children, local_router_hash[item.path].children)
      }
      obj.meta.icon = item.icon || ''
      result.push(obj);
    }
  })
  return result;
}

// 将后端返回的路由信息与本地文件匹配
export function setAddRouter() {
  const newRouter = createRouter();
  let menuLeft = store.getters.menuLeft;
  let routerSurface = _.cloneDeep(routerSurfaces); // 深拷贝路由文件
  newArray = matchNestedObjects(menuLeft, routerSurface); // 匹配后的路由
  if (menuLeft.length && menuLeft[0].path == '/index') {
    routerSurface[0].meta.icon = menuLeft[0].icon
    newArray.unshift(routerSurface[0])
  }

  // 供应商特殊路由
  if (store.getters.is_supplier && (store.getters.skip_type == 1 || store.getters.skip_type == 2)) {
    newArray.push(...supplier)
  }
  // 旗舰店特殊路由
  let goods_fits_path  = newArray.find(item => item.path == '/sourceGoods')

  if(store.getters.store_type == 2){
    let accessory_path = goods_fits_path.children.find(item => item.path == '/sourceGoods/goods')
    goods_fits_path.redirect = accessory_path.path
    let delete_index = goods_fits_path.children.findIndex(item => item.path == '/sourceGoods/accessory')
    if(delete_index != -1)goods_fits_path.children.splice(delete_index, 1)
  } else {
    let accessory_path = goods_fits_path.children.find(item => item.path == '/sourceGoods/accessory')
    goods_fits_path.redirect = accessory_path.path
    let delete_index = goods_fits_path.children.findIndex(item => item.path == '/sourceGoods/goods')
    if(delete_index != -1)goods_fits_path.children.splice(delete_index, 1)
  }

  // 储存处理完后的站点路由
  newArray.push(...routes)
  store.commit('user/setRoutes', _.cloneDeep(newArray));
  router.matcher = newRouter.matcher;
  router.addRoutes(newArray);
}

router.beforeEach(async (to, from, next) => {
  let token = sessionStorage.getItem('token');
  if(to.path == '/login'){
    next();
    return
  }
  if(!token){
    next('/login');
    return
  }
  if (store.getters.menuLeft.length) {
    next();
  } else {
    let store_info = await axios.post(api.user.shopInfo)
    // 收集权限信息
    store.commit('user/dealStoreInfo', store_info.result);
    // 获取菜单
    store.dispatch('user/get_menu',{
      success: (res) => {
        setAddRouter()
        next(to.fullPath);
      }
    })
  }
});
export default router;